import React from 'react';

export function BlobBlue() {
  return (
    <svg
      className="blob-blue pos-a"
      xmlns="http://www.w3.org/2000/svg"
      width={599}
      height={669}
      viewBox="0 0 599 669"
      fill="none"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M489.859 39.4785C576.974 114.607 612.785 237.681 592.718 350.953C573.941 456.946 484.691 527.383 393.338 584.318C302.552 640.9 200.649 688.558 97.7077 659.463C-12.2184 628.395 -105.141 543.77 -137.619 434.252C-168.585 329.831 -123.105 221.431 -58.1101 134.034C0.103068 55.7557 89.3691 16.351 185.499 -0.236812C291.575 -18.5408 408.343 -30.8222 489.859 39.4785Z"
        fill="url(#paint0_radial_blue)"
        fillOpacity={0.6}
      />
      <defs>
        <radialGradient
          id="paint0_radial_blue"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(303.849 247.312) rotate(131.545) scale(327.674 327.674)"
        >
          <stop stopColor="#CCE0FF" />
          <stop offset={0.657278} stopColor="#F0FDFF" />
          <stop offset={1} stopColor="#F0FDFF" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
}
